/**
 * Bucket labels along X (every sprint/week/release column). Mirrors the Overview
 * “Team Member Time Distribution” chart: angled ticks so dense periods stay readable,
 * {@link dynamicsPeriodAxisProps.interval}=0 avoids Recharts thinning out ticks.
 */
export const dynamicsPeriodAxisProps = {
  dataKey: 'period' as const,
  interval: 0 as const,
  angle: -45 as const,
  textAnchor: 'end' as const,
  /** Reserved height for rotated bucket text inside the svg (see Recharts XAxis docs). */
  height: 88,
  tick: { fontSize: 10 },
  tickMargin: 6,
};

/** Leaves room under the plot grid for angled labels — pair with {@link dynamicsPeriodAxisProps}. */
export const dynamicsBucketChartMargins = { top: 24, right: 24, left: 16, bottom: 12 } as const;
